import Axios from '../axios-instance';

const ClaimsStatsAPI = {
  getStats: body => {
    return Axios.post('/Claims/GetDashboardData', body).then(({ data }) => data);
  },
};

export default ClaimsStatsAPI;
